import React from 'react';
import './DesktopWTView.less';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.less';
import 'slick-carousel/slick/slick-theme.less';
import SlideItem from './SlideItem';
import { homeWalkthrogh1, homeWalkthrogh2 } from '../../../assets/brandImages';
import {
  getVersionHeaderColor,
  LocalizePropType,
  UserDataOutput,
} from 'getaway-data-layer';
import { GA_TITLES } from '../../../utils';
import LanguageSelector from '../../components/LanguageSelector/LanguageSelector';
import BrandButton from '../../components/BrandButton/BrandButton';

type Props = {
  localize: LocalizePropType;
  user: UserDataOutput;
  sliderIndex: number;
  sliderRef: any;
  afterSlide: (index: number) => void;
  onClickVersionHeader: () => void;
  onClickLogin: () => void;
  onClickNext: () => void;
};

const DesktopWTView = ({
  localize,
  sliderRef,
  afterSlide,
  onClickVersionHeader,
  onClickLogin,
  onClickNext,
}: Props) => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    dotsClass: 'slick-dots WT-slick-dots',
    autoplay: true,
    arrows: true,
  };

  const actions = (
    <>
      <div className="home-top-container">
        <div
          className="version"
          onClick={onClickVersionHeader}
          style={{ color: getVersionHeaderColor() }}
        >
          {localize('home.about')}
        </div>
        <LanguageSelector />
      </div>
      <div className={`home-bottom-container`}>
        <BrandButton
          id={GA_TITLES.AUTH.SIGN_UP}
          title={localize('home.button.title')}
          containerStyles={{ position: 'unset', width: '100%' }}
          onClick={onClickNext}
        />
        <div onClick={onClickLogin} className="signup-footnote">
          <div
            data-testid="HomeView-footnoteText"
            className={`home-footnote-text`}
          >
            {localize('signup.footnote.login.text')}
          </div>
          <div data-testid="HomeView-loginBtn" className="home-footnote-action">
            {localize('signup.footnote.login.action')}
          </div>
        </div>
      </div>
    </>
  );

  return (
    <>
      <div
        className="screen-container"
        style={{
          height: 'calc(100%)',
          top: 'unset',
          bottom: 0,
          boxShadow: '0px 0px 10px 0px rgba(0, 0, 0, 0.5)',
          zIndex: 1,
        }}
      >
        <div
          className="screen-body"
          style={{
            padding: 0,
            borderTopLeftRadius: 0,
          }}
        >
          <Slider ref={sliderRef} {...settings} afterChange={afterSlide}>
            <SlideItem
              titleTestId="DesktopView-title"
              descriptionTestId="DesktopView-description"
              title={localize(`home.walkthrough.page1.title`)}
              description={localize(`home.walkthrough.page1.description`)}
              imageSrc={homeWalkthrogh1}
              extraComponents={actions}
            />
            <SlideItem
              titleTestId="DesktopView-title"
              descriptionTestId="DesktopView-description"
              title={localize(`home.walkthrough.page2.title`)}
              description={localize(`home.walkthrough.page2.description`)}
              imageSrc={homeWalkthrogh2}
              extraComponents={actions}
            />
          </Slider>
        </div>
      </div>
    </>
  );
};

export default DesktopWTView;
